import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, ZapIcon, ShieldCheckIcon, DownloadIcon, CreditCardIcon, CrownIcon } from 'lucide-react';
const features = ['Planificación anual estructurada', 'Clases listas para aplicar', 'Actividades pensadas para adolescentes', 'Secuencia pedagógica clara', 'Recursos listos para usar', '+ 3 Bonos exclusivos GRATIS'];
const proFeatures = ['Todo lo incluido en el plan base', '+Planificación Anual resuelta de la materia Gestión nivel secundario', 'Recursos listos para usar en el aula'];
export function Pricing() {
  return <section id="comprar" className="py-10 md:py-14 bg-gradient-to-b from-primary-dark to-primary relative overflow-hidden" data-id="element-111">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-accent/15 blur-[100px] rounded-full pointer-events-none" data-id="element-112" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-113">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-2xl md:text-4xl font-extrabold text-white text-center mb-5 tracking-tight" data-id="element-114">
          🚀 Es tu turno
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-4xl mx-auto" data-id="element-115">
          {/* ORIGINAL CARD */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white rounded-2xl shadow-2xl overflow-hidden border-2 border-accent/40" data-id="element-116">
            <div className="h-1 bg-gradient-to-r from-accent via-yellow-500 to-accent" data-id="element-117" />

            <div className="bg-gradient-to-r from-primary-dark to-primary text-center py-2 px-3" data-id="element-118">
              <p className="text-white font-bold flex items-center justify-center gap-2 text-xs md:text-sm" data-id="element-119">
                <ZapIcon className="w-3.5 h-3.5 text-accent" data-id="element-120" />
                🎁 Incluye todos los bonos GRATIS
              </p>
            </div>

            <div className="p-4 md:p-5" data-id="element-121">
              <div className="space-y-2 mb-4" data-id="element-122">
                {features.map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-123">
                    <CheckCircle2Icon className="w-4 h-4 text-green-500 shrink-0" data-id="element-124" />
                    <span className="text-gray-700 font-medium text-[13px]" data-id="element-125">
                      {item}
                    </span>
                  </div>)}
              </div>

              <div className="text-center mb-4" data-id="element-126">
                <p className="text-gray-400 text-xs mb-0.5" data-id="element-127">
                  Precio Normal: <span className="line-through" data-id="element-128">$49.990</span>
                </p>
                <div className="flex items-start justify-center gap-0.5" data-id="element-129">
                  <span className="text-xl font-bold text-gray-900 mt-2" data-id="element-130">
                    $
                  </span>
                  <span className="text-5xl md:text-6xl font-extrabold text-gray-900 tracking-tight" data-id="element-131">
                    19.990
                  </span>
                </div>

                <div className="inline-block bg-green-700 text-white font-bold text-xs px-4 py-1 rounded-full mt-2" data-id="element-132">
                  ¡AHORRÁS $30.000 HOY!
                </div>

                <p className="text-gray-400 text-xs mt-2" data-id="element-133">
                  Pago único · Acceso inmediato · Sin suscripciones
                </p>
              </div>

              <a href="https://checkout.digitalmarket360.online/cart/42132758659127:1" target="_blank" rel="noopener noreferrer" className="w-full group relative flex items-center justify-center gap-2 px-5 py-3.5 text-base md:text-lg font-bold text-white bg-gradient-to-r from-green-600 to-green-700 rounded-xl overflow-hidden shadow-lg hover:shadow-xl hover:from-green-700 hover:to-green-800 transition-all transform hover:scale-[1.02]" data-id="element-134">
                <ZapIcon className="w-4 h-4" data-id="element-135" />
                DESCARGAR EL PACK AHORA
              </a>

              <p className="text-center text-gray-500 text-xs mt-2" data-id="element-136">
                👆 Hacé clic y empezá a organizar tu año
              </p>

              <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 mt-3 text-[11px] text-gray-400" data-id="element-137">
                <span className="flex items-center gap-1" data-id="element-138">
                  <ShieldCheckIcon className="w-3 h-3" data-id="element-139" /> Pago Seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-140">
                  <CreditCardIcon className="w-3 h-3" data-id="element-141" /> Todos los medios
                </span>
                <span className="flex items-center gap-1" data-id="element-142">
                  <DownloadIcon className="w-3 h-3" data-id="element-143" /> Descarga inmediata
                </span>
              </div>
            </div>
          </motion.div>

          {/* PRO CARD */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.15
        }} className="bg-white rounded-2xl shadow-2xl overflow-hidden border-2 border-yellow-400 relative" data-id="element-144">
            <div className="h-1 bg-gradient-to-r from-yellow-400 via-amber-500 to-yellow-400" data-id="element-145" />

            <div className="bg-gradient-to-r from-yellow-500 to-amber-600 text-center py-2 px-3" data-id="element-146">
              <p className="text-white font-bold flex items-center justify-center gap-2 text-xs md:text-sm" data-id="element-147">
                ⭐ Gestión & Administración 360 PRO — Mayor valor
              </p>
            </div>

            <div className="p-4 md:p-5" data-id="element-148">
              <p className="text-gray-500 text-center mb-3 text-[11px]" data-id="element-149">
                Llevate el material #1 De Gestión y Administración para docentes
                nivel secundario con un descuento exclusivo solo por hoy.
              </p>

              <div className="space-y-2 mb-4" data-id="element-150">
                {proFeatures.map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-151">
                    <CheckCircle2Icon className="w-4 h-4 text-green-500 shrink-0" data-id="element-152" />
                    <span className="text-gray-700 font-medium text-[13px]" data-id="element-153">
                      {item}
                    </span>
                  </div>)}
              </div>

              <div className="text-center mb-4" data-id="element-154">
                <p className="text-gray-400 text-xs mb-0.5" data-id="element-155">
                  Precio Normal: <span className="line-through" data-id="element-156">$99.980</span>
                </p>
                <div className="flex items-start justify-center gap-0.5" data-id="element-157">
                  <span className="text-xl font-bold text-gray-900 mt-2" data-id="element-158">
                    $
                  </span>
                  <span className="text-5xl md:text-6xl font-extrabold text-gray-900 tracking-tight" data-id="element-159">
                    29.990
                  </span>
                </div>

                <div className="inline-block bg-amber-600 text-white font-bold text-xs px-4 py-1 rounded-full mt-2" data-id="element-160">
                  ¡AHORRÁS $69.990 HOY!
                </div>

                <p className="text-gray-400 text-xs mt-2" data-id="element-161">
                  Pago único · Acceso inmediato · Sin suscripciones
                </p>
              </div>

              <a href="https://checkout.digitalmarket360.online/cart/42132763377719:1" target="_blank" rel="noopener noreferrer" className="w-full group relative flex items-center justify-center gap-2 px-5 py-3.5 text-base md:text-lg font-bold text-white bg-gradient-to-r from-amber-500 to-amber-600 rounded-xl overflow-hidden shadow-lg hover:shadow-xl hover:from-amber-600 hover:to-amber-700 transition-all transform hover:scale-[1.02]" data-id="element-162">
                <CrownIcon className="w-4 h-4" data-id="element-163" />
                ACCEDER AL PLAN PRO
              </a>

              <p className="text-center text-gray-500 text-xs mt-2" data-id="element-164">
                👆 La mejor inversión para tu carrera docente
              </p>

              <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 mt-3 text-[11px] text-gray-400" data-id="element-165">
                <span className="flex items-center gap-1" data-id="element-166">
                  <ShieldCheckIcon className="w-3 h-3" data-id="element-167" /> Pago Seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-168">
                  <CreditCardIcon className="w-3 h-3" data-id="element-169" /> Todos los medios
                </span>
                <span className="flex items-center gap-1" data-id="element-170">
                  <DownloadIcon className="w-3 h-3" data-id="element-171" /> Descarga inmediata
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}